import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=0e1c5090&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1c5090')) {
      api.createRecord('0e1c5090', component.options)
    } else {
      api.reload('0e1c5090', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=0e1c5090&", function () {
      api.rerender('0e1c5090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wpUmQQx5xiei/JS/comp/stardisplay.vue"
export default component.exports